/**
 * "Not now" on the owner's "No one has reported feeling sick" note (core zeroreports.ts): this browser remembers the day it
 * stays hidden until, per business and place. A per-viewer convenience: if storage is blocked the note simply comes back.
 */
const key = (orgId: string, locationId: string) => `cc.zeroReports.${orgId}.${locationId}`;

export function readZeroSnooze(orgId: string, locationId: string): string | null {
  try { return localStorage.getItem(key(orgId, locationId)); } catch { return null; }
}
export function writeZeroSnooze(orgId: string, locationId: string, until: string): void {
  try { localStorage.setItem(key(orgId, locationId), until); } catch { /* private mode: the note may return sooner, never blocks */ }
}
